/* eslint-disable import/no-named-as-default-member */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import { Dimmer, Loader, Image, Button } from 'semantic-ui-react'
import LogoCropUploader from '../../../lib/LogoCropUploader'

export default class LogoField extends React.PureComponent {
  state = {
    visible: false,
    logoLoaded: false,
    loading: false,
  }

  onUploadClick = () => {
    this.setState({ visible: true })
  }

  onClose = () => {
    this.setState({ visible: false })
  }

  setLoading = (loadingState) => {
    this.setState({ loading: loadingState})
  }

  renderHasLogo = logo => {
    const { logoLoaded, loading } = this.state

    return (
      <div>
        <div style={{ width: 150, height: 150, position: 'relative' }}>
          <Image
            src={logo}
            style={{ width: 150, height: 150 }}
            onLoad={() => this.setState({ logoLoaded: true })}
          />
          {(!logoLoaded || loading) && (
            <Dimmer active>
              <Loader />
            </Dimmer>
          )}
        </div>
      </div>
    )
  }

  renderUploader = () => {
    return (
      <div onClick={this.onUploadClick}>
        <div style={{ width: 150, height: 150 }}>
          <Image
            src={require('../../../assets/images/placeholder.png')}
            style={{ width: 150, height: 150 }}
          />
        </div>
      </div>
    )
  }

  render = () => {
    const { store, storeId, fetchStore } = this.props
    const { visible } = this.state
    const logo = (store && store.images && store.images.logo) || null

    return (
      <div>
        {logo ? this.renderHasLogo(logo) : this.renderUploader()}
        <div style={{ marginTop: 10 }}>
          <Button size="mini" onClick={this.onUploadClick}>
            {logo ? 'Change' : 'Upload'}
          </Button>
        </div>
        <LogoCropUploader
          visible={visible}
          setLoading={this.setLoading}
          label="Logo"
          onClose={this.onClose}
          onUploadComplete={fetchStore}
          compressWidth={250}
          compressHeight={250}
          uploadPath={`restaurants/${storeId}`}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/logoField.js